var selected_product_dom = `<img src="##image##"><div class="product-details">##product-title##</div>`;
var pos = 1;

document.addEventListener('DOMContentLoaded', function() {
  // open popup
  var popupTriggers = document.querySelectorAll('.cd-popup-trigger');
  popupTriggers.forEach(function(trigger) {
    trigger.addEventListener('click', function(event) {
      pos = this.dataset.pos;
      event.preventDefault();
      var free_product_list = ``;
      
      if(pos == 3) {
        all_free_coin_purse.forEach(function(product) {
          free_product_list += free_product_dom.replace('##title##', product.product_title).replaceAll('##id##', product.id).replace('##image##', product.img).replace('##pos##', pos);
        }); 
        document.querySelector('.cd-popup-container h1').innerText = `Select a ${popup_title_3}`;
      } else {
        all_free_straps.forEach(function(product) {
          free_product_list += free_product_dom.replace('##title##', product.product_title).replaceAll('##id##', product.id).replace('##image##', product.img).replace('##pos##', pos);
        });
        document.querySelector('.cd-popup-container h1').innerText = "SELECT A FREE STRAP";
      }        
      
      var container = document.querySelector('.free-product-container');
      if (container) {
          container.innerHTML = free_product_list;
      }
      
      document.querySelectorAll('.cd-popup').forEach(function(popup) {
          popup.classList.add('is-visible');
      });
    });
  });
  
  // close popup
  var popups = document.querySelectorAll('.cd-popup');
  popups.forEach(function(popup) {
    popup.addEventListener('click', function(event) {
      if (event.target.matches('.cd-popup-close') || event.target.matches('.cd-popup')) {
        event.preventDefault();
        this.classList.remove('is-visible');
      }
    });
  });

  // close popup when clicking the esc keyboard button
  document.addEventListener('keyup', function(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      document.querySelectorAll('.cd-popup').forEach(function(popup) {
          popup.classList.remove('is-visible');
      });
    }
  });

  // Select all elements with the class 'product-form__buttons'
  const buttons = document.querySelectorAll('.payment-buttons');

  // Select all elements with the class 'free-products'
  const freeProducts = document.querySelectorAll('.free-products');

  // Iterate over each button element and attach the event listeners
  buttons.forEach(function(button) {
    button.addEventListener('mouseenter', function() {
      freeProducts.forEach(function(product) {
        product.classList.add('tilt-animate');
      });
    });

    button.addEventListener('mouseleave', function() {
      freeProducts.forEach(function(product) {
        product.classList.remove('tilt-animate');
      });
    });
  });
});

function selectProduct(id, pos) {
  var selectElement = document.querySelector('select[data-product-select].product-single__variants.no-js');
  if (selectElement) {
      selectElement.name = "id[]";
  }
  
  var all_products = (pos == 3) ? all_free_coin_purse : all_free_straps;
  var selected_variant = all_products.find(variant => variant.id === id);
  var d;

  if (selected_variant.img) {
      d = selected_product_dom.replaceAll('##image##', selected_variant.img)
                              .replaceAll('##product-title##', selected_variant.product_title);
  } else {
      d = selected_product_dom.replaceAll('##image##', "")
                              .replaceAll('##product-title##', selected_variant.product_title);
  }

  document.querySelectorAll('.cd-popup').forEach(function(popup) {
      popup.classList.remove('is-visible');
  });

  // Determine which product div to update based on 'pos'
  var productDivId;
  // Use loose equality or cast pos to integer in case it comes through as a string from dataset
  switch (parseInt(pos)) {
      case 1:
          productDivId = '#free-product-one';
          break;
      case 2:
          productDivId = '#free-product-two';
          break;
      case 3:
          productDivId = '#free-product-three';
          break;
      default:
          console.error('Invalid position provided:', pos);
          return;
  }

  var targetDiv = document.querySelector(productDivId);
  if (targetDiv) {
      targetDiv.innerHTML = d;
  }

  // Select the element with the class 'product-single__variants'
  let variantElement = document.querySelector('.product-single__variants');

  if (variantElement) {
      // Determine the ID of the hidden input based on 'pos'
      var hiddenInputId = 'free-product-selected-' + pos;
      
      // Check if an element with the corresponding ID already exists
      let existingInput = document.getElementById(hiddenInputId);

      if (existingInput) {
          // Replace the value if the hidden input already exists
          existingInput.value = id; // Set the desired value here
      } else {
          // Create a new hidden input element
          let hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = 'id[]';
          hiddenInput.className = 'product-single__variants no-js';
          hiddenInput.id = hiddenInputId;
          hiddenInput.value = id; // Set the desired value here

          // Insert the hidden input after the selected element
          variantElement.parentNode.insertBefore(hiddenInput, variantElement.nextSibling);
      }
  }
}

function addPreselectedStraps(preselectedProducts) {
  const addButton = document.getElementById('add-strap-button');
  if (addButton) addButton.classList.add('btn--loading');
  
  let formData = {
    'items': preselectedProducts
  };

  fetch(theme.routes.cartAdd, {
    method: 'POST',
    body: JSON.stringify(formData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(response => response.json())
  .then(function(data) {
      if (addButton) addButton.classList.remove('btn--loading');
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {}
      }));
  })
  .catch(function(error) {
    if (addButton) addButton.classList.remove('btn--loading');
    console.error('Error adding product to cart:', error);
  });
}

function addPreselectedStrapsAlt(preselectedProducts) {
  const addButton = document.getElementById('add-strap-button-alt');
  if (addButton) addButton.classList.add('btn--loading');
  
  // 1. Generate a unique bundle ID
  const bundleId = 'bundle_' + Date.now() + '_' + Math.random().toString(36).substring(2, 9);
  
  const items = [];

  // 2. Add the main product (supports passing a single object or an array of one)
  const mainProductsArray = Array.isArray(preselectedProducts) ? preselectedProducts : [preselectedProducts];
  mainProductsArray.forEach(product => {
    items.push({
      id: parseInt(product.id),
      quantity: product.quantity || 1,
      properties: {
        ...(product.properties || {}),
        _bundle_id: bundleId
      }
    });
  });

  // 3. Add item(s) from all_free_straps
  if (typeof all_free_straps !== 'undefined' && all_free_straps.length > 0) {
    const selectedStraps = all_free_straps.slice(0, 2);
    selectedStraps.forEach(item => {
      items.push({ 
        id: parseInt(item.id), 
        quantity: 1,
        properties: {
          _bundle_id: bundleId
        }
      });
    });
  }

  // 4. Add item(s) from all_free_coin_purse
  // if (typeof all_free_coin_purse !== 'undefined' && all_free_coin_purse.length > 0) {
  //   const selectedPurses = all_free_coin_purse.slice(0, 1);
  //   selectedPurses.forEach(item => {
  //     items.push({ 
  //       id: parseInt(item.id), 
  //       quantity: 1,
  //       properties: {
  //         _bundle_id: bundleId
  //       }
  //     });
  //   });
  // }

  // 5. Compile the final payload
  let formData = {
    'items': items
  };

  // 6. Send to Shopify Cart API
  fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
    method: 'POST',
    body: JSON.stringify(formData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(response => {
    if (!response.ok) {
       return response.json().then(err => { throw err; });
    }
    return response.json();
  })
  .then(function(data) {
      if (addButton) addButton.classList.remove('btn--loading');
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          cart: data
        }
      }));
  })
  .catch(function(error) {
    if (addButton) addButton.classList.remove('btn--loading');
    console.error('Error adding product to cart:', error);
  });
}

function addStrapsToCart() {
  const addButton = document.getElementById('add-strap-button');
  if (addButton) addButton.classList.add('btn--loading');
  
  var productInputs = document.querySelectorAll('input[name="id[]"]');
  let productIds = [];
  productInputs.forEach(function(input) {
    productIds.push({
      id: input.value,
      quantity: 1
    });
  });  
  
  let formData = {
    'items': productIds
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    body: JSON.stringify(formData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(response => response.json())
  .then(function(data) {
      if (addButton) addButton.classList.remove('btn--loading');
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {}
      }));
  })
  .catch(function(error) {
    if (addButton) addButton.classList.remove('btn--loading');
    console.error('Error adding product to cart:', error);
  });
}